<template>
  <div class="rigth_Infwarp">
    <el-card style="height:100%">
      <p>人口受教育程度分析</p>
      <div class="infro" ref="MyEcharts"></div>
    </el-card>
  </div>
</template>

<script>
import { dataValueDshouJiao } from "@/network";
export default {
  data() {
    return {};
  },
  created() {},
  mounted() {
    this.getEchartValue();
  },
  methods: {
    async getEchartValue() {
      const { code, data, msg } = await dataValueDshouJiao();
      if (code == 200) {
        // 获取内容
        let counst = data.classifyVos.map((item) => ({
          name: item.title,
          max: item.cnt * 3, //最大值 * 3
        }));
        // 获取标题tabr
        let title = [];
        for (const item of data.classifyEdus) {
          title.push(item.quarter);
        }

        this.getInfo(data.classifyEdus, title, counst);
      }
    },
    getInfo(datalist, title, counst) {
      let myehcarts = this.$echarts.init(this.$refs.MyEcharts);
      let option = {
        legend: {
          data: title,
          type: "scroll",
          orient: "vertical",
          right: 30,
          y: "center",
          padding: [0, 50, 0, 0],
        },
        tooltip: {
          trigger: "axis",
        },
        radar: {
          // shape: 'circle',
          indicator: counst, //标题内容最大值
        },
        series: [
          {
            // name: "预算 vs 开销（Budget vs spending）",
            type: "radar",
            areaStyle: {},
            tooltip: {
              trigger: "item",
            },
            data: [
              {
                value: datalist[0].num,
                name: title[0],
              },
              {
                value: datalist[1].num,
                name: title[1],
                // areaStyle: {
                //   color: "rgba(255, 228, 52, 0.6)",
                // },
              },
              {
                value: datalist[2].num,
                name: title[2],
              },
              {
                value: datalist[3].num,
                name: title[3],
              },
            ],
          },
        ],
      };
      myehcarts.setOption(option);
    },
  },
};
</script>

<style lang="less">
.rigth_Infwarp {
  height: 450px;
  margin: 10px 0;
  .el-card__body {
    height: 100%;
    .infro {
      height: 90%;
    }
  }
}
</style>
